import { Particle, type ParticleOptions } from "../Particle";
import { adjustColor } from "../../utils/color";
import { TemperatureNormalization } from "../behaviors/TemperatureNormalization";

/**
 * 基岩粒子
 * 特性：不可燃，不可碾碎，坚不可摧
 */
export class Bedrock extends Particle {
    static baseColor = 0x2F363D; // Dark Slate Grey

    constructor(options: Partial<ParticleOptions> = {}) {
        super({
            name: "Bedrock",
            color: adjustColor(Bedrock.baseColor, 10), // 稍微有些颜色变化
            behaviors: [
                new TemperatureNormalization(20, 0.05) // 极慢恢复温度
            ],
            props: { 
                isMixable: false, 
                thermalConductivity: 0.01, // 极低导热率
                isFlammable: false, // 显式声明不可燃
                density: 100 // 极高密度
            },
            temperature: 20,
            minTemp: -273,
            maxTemp: 10000, // 极高熔点
            ...options
        });
    }
}
